import PropTypes from "prop-types";
import { useState } from "react";
import { useGeolocated } from "react-geolocated";
import GoogleMapReact from "google-map-react";
import {
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  Typography,
  Box,
  Button,
  IconButton,
} from "@mui/material";

function CurrentGPSLocation({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  // const AnyReactComponent = ({ text }) => <div>{text}</div>;
  // const defaultProps = {
  //   center: {
  //     lat: 10.99835602,
  //     lng: 77.01502627,
  //   },
  //   zoom: 11,
  // };

  const [gpsLocationCoords, setGpsLocationCoords] = useState(null);
  const [openMapDialog, setOpenMapDialog] = useState(false);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
        // maximumAge: 0,
      },
      // watchPosition: true,
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }
    return false;
  }

  function captureLocation() {
    setGpsLocationCoords(
      JSON.stringify({
        latitude: coords.latitude,
        longitude: coords.longitude,
      })
    );
  }

  // console.log(options);
  return (
    <Box mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openMapDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box>Current Location</Box>
        </DialogTitle>
        <DialogContent>
          <Box mt={2} mb={3}>
            {coords ? (
              <div style={{ height: "100vh", width: "100%" }}>
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0",
                  }}
                  defaultCenter={{
                    lat: coords.latitude,
                    lng: coords.longitude,
                  }}
                  defaultZoom={14}
                >
                  <Icon
                    fontSize="large"
                    color="error"
                    lat={coords.latitude}
                    lng={coords.longitude}
                    text="Current Location"
                  >
                    pin_drop
                  </Icon>
                </GoogleMapReact>
              </div>
            ) : (
              <> </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenMapDialog(false);
            }}
            color="secondary"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </Button>
          &nbsp;
          <Button
            color="info"
            variant="outlined"
            iconOnly
            circular
            onClick={() => {
              setOpenMapDialog(false);
              captureLocation();
            }}
          >
            <Icon>save</Icon>
          </Button>
        </DialogActions>
      </Dialog>
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8} lg={8}>
            <Typography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </Typography>
          </Grid>
          <Grid item xs={4} md={4} lg={4}>
            <Box align="right">
              <IconButton
                iconOnly
                size="small"
                variant="contained"
                color="primary"
                // startIcon={<Icon>location_on</Icon>}
                onClick={() => {
                  const gpsCoords = getGPSCoords();
                  if (gpsCoords === false) {
                    console.log(options);
                    setErrorMsg(
                      "Unable to retrieve your current location. Make sure Location permissions are allowed on your browser."
                    );
                    showFieldError(true);
                    return;
                  }
                  setGpsLocationCoords(null);
                  setOpenMapDialog(true);
                }}
              >
                <Icon>gps_fixed</Icon>
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        {gpsLocationCoords !== null && coords ? (
          <Typography variant="caption" fontSize={14} fontWeight="light">
            <b>
              <Icon color="error">pin_drop</Icon>&nbsp;GPS Captured
            </b>
            <br />
            <small>
              Latitude: {coords.latitude} | Longitude: {coords.longitude}
            </small>
          </Typography>
        ) : (
          <> </>
        )}
      </Box>
      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={`${fieldRef}`}
        value={gpsLocationCoords}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
CurrentGPSLocation.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

CurrentGPSLocation.defaultProps = {
  options: null,
};

export default CurrentGPSLocation;
